import { Entity } from '@backstage/catalog-model';

const HOST = 'host';
const PORT = 'port';
const REDIS_METADATA = 'redis';
const USERNAME = 'username';
const DB = 'db';

export const isRedisMetadataAvailable = (entity: Entity) =>
  Boolean(entity.metadata[REDIS_METADATA]);

export const getHost = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[REDIS_METADATA]?.[HOST] ?? undefined;
};

export const getPort = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[REDIS_METADATA]?.[PORT] ?? undefined;
};

export const getUsername = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  return metadata?.[REDIS_METADATA]?.[USERNAME] ?? undefined;
};

export const getDb = (entity: Entity): string | undefined => {
  const metadata = entity?.metadata as Record<string, any> | undefined;
  if (metadata?.[REDIS_METADATA]?.[DB] === 0) return '0';
  return metadata?.[REDIS_METADATA]?.[DB] ?? undefined;
};
